<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备名称：</span>
        </div>
        <el-input v-model="formData.deviceName" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备编号：</span>
        </div>
        <el-input v-model="formData.deviceCode" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备厂商：</span>
        </div>
        <el-select v-model="formData.deviceManufacturerCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceManufacturerList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">设备型号：</span>
        </div>
        <el-select v-model="formData.deviceModelCode" size="small" style="width: 280px">
          <el-option v-for="item in deviceModelList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">设备位置：</span>
        </div>
        <el-input v-model="formData.deviceLocation" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">端口号：</span>
        </div>
        <el-input v-model="formData.gatewayDeviceInterface" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">最小阈值：</span>
        </div>
        <el-input v-model="formData.minimumThreshold" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">最大阈值：</span>
        </div>
        <el-input v-model="formData.maximumThreshold" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联网关：</span>
        </div>
        <el-select v-model="formData.parentCode" size="small" style="width: 280px">
          <el-option v-for="item in gatewayDeviceList" :key="item.deviceCode"
                     :label="item.deviceName" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../../utils/toBase64'
  import $ from 'jquery'
  import {api} from '../../../api/FireControl'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {errorHandler} from '../../../../utils/errorHandler'
  import UploadImgList from '../../../../components/Input/UploadImgList'

  export default {
    components: {
      UploadImgList,
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'level-device-add',
    data () {
      return {
        breadcrumb: [{
          value: '智慧消防',
          name: 'fire-over-view'
        }, {
          value: '液压设备'
        }],
        mainTitle: '添加液压设备',
        subheading: '',

        buildingList: [],
        floorList: [],

        deviceManufacturerList: [
          {
            code: '大麦',
            name: '大麦'
          }
        ],

        deviceModelList: [
          {
            code: 'DM-FC-Y001',
            name: 'DM-FC-Y001'
          }
        ],

        gatewayDeviceList: [],

        formData: {
          deviceName: '',
          deviceCode: '',
          deviceType: '2',
          deviceManufacturerName: '',
          deviceManufacturerCode: '大麦',
          deviceModelName: '',
          deviceModelCode: 'DM-FC-Y001',
          parentCode: '',
          parentName: '',
          gatewayDeviceInterface: '',
          maximumThreshold: '',
          minimumThreshold: '',
        },

      }
    },
    created () {
      this.getGatewayDeviceList()
    },
    methods: {
      // 获取网关列表
      getGatewayDeviceList () {
        this.$axios.post(api.getGatewayDeviceList, {})
          .then(res => {
            this.gatewayDeviceList = res.data.data
          })
          .catch(errorHandler('获取网关列表失败'))
      },

      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },

      toManagePage () {
        this.$router.push({
          name: 'level-device-manage'
        })
      },

      confirm () {
        if (!this.formData.deviceName) {
          nError('请输入设备名称')
          return false
        }
        if (!this.formData.deviceCode) {
          nError('请输入设备编号')
          return false
        }
        if (!this.formData.parentCode) {
          nError('请选择关联网关')
          return false
        }
        if (!this.formData.gatewayDeviceInterface) {
          nError('请输入端口号')
          return false
        }
        if (!this.formData.minimumThreshold) {
          nError('请输入最小阈值')
          return false
        }
        if (!this.formData.maximumThreshold) {
          nError('请输入最大阈值')
          return false
        }
        this.deviceManufacturerList.map(v => {
          if (v.code === this.formData.deviceManufacturerCode) {
            this.formData.deviceManufacturerName = v.name
          }
        })
        this.deviceModelList.map(v => {
          if (v.code === this.formData.deviceModelCode) {
            this.formData.deviceModelName = v.name
          }
        })
        this.gatewayDeviceList.map(v => {
          if (v.deviceCode === this.formData.parentCode) {
            this.formData.parentName = v.deviceName
          }
        })
        this.$axios.post(api.addHydraulicDevice, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('添加成功')
              this.toManagePage()
            }
          })
          .catch(errorHandler('添加失败'))
      },
      cancel () {
        this.toManagePage()
      }
    },
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 28px;
    line-height: 40px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 20px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 80px;
    height: 80px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .invoice-tax-rate-add {
    .el-switch {
      height: 30px;
    }
    .el-input-number.is-controls-right .el-input__inner {
      text-align: left;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/FireControl/FireControlDeviceManage/LevelDeviceManage/LevelDeviceAdd.vue